/*
===============================================================================================================
                                 Copyright 2026-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LuminatePortalErrorScreen() {
  const { t } = useTranslation();
  return (
    <div className="luminate-portal-error-screen">
      <p className="luminate-portal-error-screen-message">
        {t('constants.luminatePortalConfigError')}
      </p>
      <style jsx>
        {`
          .luminate-portal-error-screen {
            position: fixed;
            left: 0;
            top: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 1rem;
            background-color: var(--color-white);
            padding: 1.5rem;
          }

          .luminate-portal-error-screen-message {
            margin: 0;
            text-align: center;
          }
        `}
      </style>
    </div>
  );
}
